import { render, staticRenderFns } from "./marketing-secondcommdityclassifi.vue.vue?vue&type=template&id=71132404&scoped=true&"
import script from "./marketing-secondcommdityclassifi.vue.vue?vue&type=script&lang=js&"
export * from "./marketing-secondcommdityclassifi.vue.vue?vue&type=script&lang=js&"
import style0 from "./marketing-secondcommdityclassifi.vue.vue?vue&type=style&index=0&id=71132404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71132404",
  null
  
)

export default component.exports